import { APIClient } from "../api/ApiClient";
import {
  CommonDataResponse,
  ManagerItem,
} from "../../types/CommonDataRequestTypes";

import { Status } from "../../enums/Status";
import { API_ROUTES } from "../api/config";
import { MESSAGES } from "../../messages";
import { CompassError } from "../../types/errorTypes";

export const getManagers = async (
  params: null,
  authToken: string
): Promise<CommonDataResponse<ManagerItem[]>> => {
  const api = new APIClient();

  const customConfig = {
    headers: {
      token: authToken,
    },
  };

  try {
    const managersResponse: CommonDataResponse<ManagerItem[]> = await api.post<
      CommonDataResponse<ManagerItem[]>,
      null
    >(API_ROUTES.GET_ALL_MANAGERS, params, customConfig);

    const managers: ManagerItem[] = managersResponse.data || [];

    return {
      status: Status.SUCCESS,
      message: MESSAGES.GET_FUND_NAMES_SUCCESS,
      data: managers,
    };
  } catch (error) {
    console.error("Failed to retrieve fund names:", error);
    return {
      status: Status.ERROR,
      message: MESSAGES.GET_FUND_NAMES_ERROR,
      error: error as CompassError,
    };
  }
};
